import { Controller } from "@hotwired/stimulus"

// Toggles the _destroy hidden field for a subscription version based on checkbox state.
export default class extends Controller {
  static targets = ["destroy"]

  changed() {
    this.destroyTarget.value = this.element.querySelector('.activate_version').checked ? false : true
  }
}
